export { default } from "./TeacherStudentDirectoryTable";
